// Avatar URLs for branded data sources
export const WILEY_AVATAR = '/static/images/data-connectors/wiley/wiley-avatar.svg';
export const CBINSIGHTS_AVATAR = '/static/images/data-connectors/cbinsights/cbinsights-avatar.svg';
export const PITCHBOOK_AVATAR = '/static/images/data-connectors/pitchbook/pitchbook-avatar.svg';
export const STATISTA_AVATAR = '/static/images/data-connectors/statista/statista-avatar.svg';
export const SPRINGER_AVATAR = '/static/images/data-connectors/springer/springer-avatar.svg';
export const MIDPAGE_AVATAR = '/static/images/data-connectors/midpage/midpage-avatar.svg';
export const VISUALDX_AVATAR = '/static/images/data-connectors/visualdx/visualdx-avatar.svg';
export const NEJM_AVATAR = '/static/images/data-connectors/nejm/nejm-avatar.svg';
export const BMJ_AVATAR = '/static/images/data-connectors/bmj/bmj-avatar.svg';
export const EBSCO_AVATAR = '/static/images/data-connectors/ebsco/ebsco-avatar.svg';
// Display names for branded data sources
export const WILEY_FORMATTED_NAME = 'Wiley';
export const CBINSIGHTS_FORMATTED_NAME = 'CB Insights';
export const PITCHBOOK_FORMATTED_NAME = 'PitchBook';
export const STATISTA_FORMATTED_NAME = 'Statista';
export const SPRINGER_FORMATTED_NAME = 'Springer';
export const MIDPAGE_FORMATTED_NAME = 'Midpage';
export const VISUALDX_FORMATTED_NAME = 'VisualDx';
export const NEJM_FORMATTED_NAME = 'NEJM';
export const BMJ_FORMATTED_NAME = 'The BMJ';
export const EBSCO_FORMATTED_NAME = 'EBSCOhost';
//# sourceMappingURL=consts.js.map